import { resolve } from "inversify-react";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { actions as homeActions } from "src/actions/home.actions";
import { actions } from "src/actions/main.actions";
import { actions as nameActions } from "src/actions/name.actions";
import Container from "src/core/ui/container";
import Grid from "src/core/ui/grid";
import Icon from "src/core/ui/icon";
import Modal from "src/core/ui/modal";
import { Col } from "../../core/ui/grid";
import IdentityService from "../../services/identity.service";
import { IApplicationState, Identity } from "../../typings";

interface IActivateProps extends RouteComponentProps<{uid: string, key: string}> {
    identity: Identity;
}

type ActivateProps = IActivateProps & typeof actions & typeof homeActions;
interface IActivateState {
    uidErrors?: string[];
    keyErrors?: string[];
    generalErrors?: string[];
    detailError?: string;
    success: boolean;
    loading: boolean;
}

class Activate extends React.Component<ActivateProps, IActivateState> {

    @resolve
    public identity: IdentityService;

    constructor(props: any) {
    super(props);
    this.state =  {
            success: false,
            loading: false,
        };
    }

    public componentDidMount() {

        this.setState({loading: true});

        this.identity.activate(this.props.match.params.uid, this.props.match.params.key).then((result) => {
            this.setState({success: true, loading: false});

        })
        .catch((error) => {
            this.setState({
                uidErrors: error.uid,
                keyErrors: error.token,
                generalErrors: error.non_field_errors,
                detailError: error.detail,
                loading: false,
            });
        })
        ;
    }

    public renderErrrors = () => {

        return (
            <React.Fragment>
                    <p>Ops, sorry, your registration is not correct</p>
                    {this.state.uidErrors && this.state.uidErrors.map((item, index) => {
                        return <p className="error general-errors" key={"uid" + index}>{item}</p>;
                    })}

                    {this.state.keyErrors && this.state.keyErrors.map((item, index) => {
                        return <p className="error general-errors" key={"uid" + index}>{item}</p>;
                    })}

                    {this.state.generalErrors && this.state.generalErrors.map((item, index) => {
                        return <p className="error general-errors" key={"uid" + index}>{item}</p>;
                    })}

                    <p className="error">{
                        this.state.detailError
                    }</p>
            </React.Fragment>
        );
    }

    public loginAndChange = () => {
        this.props.history.push("/");
        this.props.toggleLogin(true, 0);
    }

    public render() {
        return (
            <React.Fragment>
                <Modal
                    visible={true}
                    type="dark"
                    size="complete"
                    closable={true}
                    className="fixed"
                    onCancel={() => this.props.history.push("/")}
                >
                <div className="verification-message">
                    <Grid centered={true}>
                        <Col className="center-vertical" size={20}>

                        <div className="iconified wire wire-1 light scale-2 not-mobile">
                            <Icon  type="envelop"/>
                        </div>
                        </Col>
                        <Col size={50}>
                        <h1>
                            Your account is being verified...
                        </h1>
                        <div className="iconified wire wire-1 light scale-2 mobile">
                            <Icon  type="envelop"/>
                        </div>
                        {(this.state.keyErrors || this.state.uidErrors || this.state.generalErrors || this.state.detailError) &&
                        this.renderErrrors()}
                            {this.state.loading && <p>

                                You will recevie and email once your account is verified, meanwhile you can explore our gallery.
                            </p>}
                            {this.state.success &&
                                <React.Fragment>
                                    <p>Your accout has been registered, welcome to Encrypto Art.</p>

                                    <p className="sign-up-link">You can <a onClick={this.loginAndChange}>Log in</a> right now</p>

                                </React.Fragment>

                            }
                        <p>

                        </p>
                        </Col>
                    </Grid>

                    </div>
                </Modal>
                <Container>

                </Container>
            </React.Fragment>
        );
    }

    public componentWillReceiveProps(nextProps: ActivateProps) {
        if (nextProps.identity.isAuthenticated) {
            this.props.history.push("/");
        }
    }
}

function mapStateToProps(state: IApplicationState, ownProps: ActivateProps): ActivateProps {
    return {
        identity: state.identity,
        ...ownProps,
        };
}
export default connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(Activate);



// WEBPACK FOOTER //
// ./src/components/account/activate.tsx